var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cancel_svg__cancel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cancel_svg__Vector (Stroke)",
    d: "M17.1263 5.81287C17.4192 5.52002 17.894 5.5201 18.1869 5.81287C18.4798 6.10577 18.4798 6.58053 18.1869 6.87342L13.0599 11.9994L18.1869 17.1263C18.4798 17.4192 18.4798 17.894 18.1869 18.1869C17.894 18.4798 17.4192 18.4798 17.1263 18.1869L11.9994 13.0599L6.87342 18.1869C6.58053 18.4798 6.10577 18.4798 5.81287 18.1869C5.5201 17.894 5.52002 17.4192 5.81287 17.1263L10.9388 11.9994L5.81287 6.87342C5.51998 6.58053 5.51998 6.10577 5.81287 5.81287C6.10577 5.51998 6.58053 5.51998 6.87342 5.81287L11.9994 10.9388L17.1263 5.81287Z",
    fill: "currentColor"
  }))));
};
export default SvgCancel;